import * as actionTypes from './actionTypes';
import { TypeProfileModel } from '@app/src/views/StepPayment/formPayment/models/TypeProfileModel';

interface State {
  data: TypeProfileModel;
  isFetching: boolean;
  isFetchingCreate: boolean;
  isFetchingUpdate: boolean;
  error: boolean;
  errorCreate: boolean;
  errorUpdate: boolean;
  isDisabledInputs: boolean;
}

const initialState: State = {
  data: {},
  isFetching: false,
  isFetchingCreate: false,
  isFetchingUpdate: false,
  error: false,
  errorCreate: false,
  errorUpdate: false,
  isDisabledInputs: false
}

export const ruc = (state: State = initialState, action) => {
  switch(action.type) {
    case actionTypes.FETCH_RUC_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_RUC_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_RUC_SUCCESS:
        return {
          ...state,
          isFetching: false,
          error: false,
          data: action.data
        }
    case actionTypes.CREATE_RUC_REQUEST:
      return {
        ...state,
        isFetchingCreate: true
      }
    case actionTypes.CREATE_RUC_FAILURE:
      return {
        ...state,
        isFetchingCreate: false,
        errorCreate: true
      }
    case actionTypes.CREATE_RUC_SUCCESS:
      return {
        ...state,
        isFetchingCreate: false,
        errorCreate: false,
        data: action.data
      }
    case actionTypes.UPDATE_RUC_REQUEST:
      return {
        ...state,
        isFetchingUpdate: true
      }
    case actionTypes.UPDATE_RUC_FAILURE:
      return {
        ...state,
        isFetchingUpdate: false,
        errorUpdate: true
      }
    case actionTypes.UPDATE_RUC_SUCCESS:
      return {
        ...state,
        isFetchingUpdate: false,
        errorUpdate: false,
        data: action.data
      }
    case actionTypes.SET_DISABLED_RUC_INPUTS:
      return {
        ...state,
        isDisabledInputs: action.isDisabled
      }
    case actionTypes.CLEAR_RUC_DATA:
      return {
        ...state,
        data: initialState.data
      }
    default:
      return state;
  }
}
